module.exports = __webpack_public_path__ + "static/media/jarradPic.2cfcd851.png";